/*********************** Custom JS for Boost AI Search & Discovery  ************************/

console.log('[Boost Custom] Script loaded - v1.1');

if (window.boostSDAppConfig) {
  window.boostSDAppConfig.integration = Object.assign(
    { wishlists: 'smart' },
    window.boostSDAppConfig.integration || {}
  );
  console.log('[Boost Custom] Integration config set:', window.boostSDAppConfig.integration);
}

// Add wishlist icons to Boost products
(function() {
  console.log('[Boost Custom] Wishlist integration starting');
  var isProcessing = false;
  
  function addWishlistIcons() {
    if (isProcessing) return;
    isProcessing = true;
    
    console.log('[Boost Custom] Adding wishlist icons...');
    
    setTimeout(function() {
      // Find all Boost product items
      const productItems = document.querySelectorAll('.boost-sd__product-item');
      
      console.log('[Boost Custom] Found', productItems.length, 'Boost products');
      
      productItems.forEach(function(item) {
        // Check if wishlist icon already exists
        if (item.querySelector('.smartwishlist')) {
          return;
        }
        
        // Get product ID and variant ID
        const productId = item.getAttribute('data-product-id');
        if (!productId) return;
        
        // Try to get variant ID from the data-product JSON
        let variantId = '';
        try {
          const dataProductAttr = item.getAttribute('data-product');
          if (dataProductAttr) {
            const productData = JSON.parse(dataProductAttr.replace(/&quot;/g, '"'));
            if (productData.variants) {
              const variants = JSON.parse(productData.variants.replace(/\\"/g, '"'));
              if (variants && variants.length > 0) {
                variantId = variants[0].id;
              }
            }
          }
        } catch (e) {
          // Silently fail on parse errors
        }
        
        // If no variant ID, try first available variant
        if (!variantId) {
          variantId = productId;
        }
        
        // Find the image wrapper
        const imageWrapper = item.querySelector('.boost-sd__product-image-wrapper');
        if (!imageWrapper) return;
        
        // Create wishlist icon
        const wishlistIcon = document.createElement('span');
        wishlistIcon.className = 'smartwishlist coll-wishlist';
        wishlistIcon.setAttribute('data-product', productId);
        wishlistIcon.setAttribute('data-variant', variantId);
        
        // Insert wishlist icon into image wrapper
        imageWrapper.appendChild(wishlistIcon);
      });
      
      // Trigger Smart Wishlist to initialize new icons
      setTimeout(function() {
        // Primary method: ReloadSmartWishlist function (used in boost-pfs-filter.v2.js)
        if (typeof ReloadSmartWishlist !== 'undefined') {
          ReloadSmartWishlist();
        } else if (typeof window.ReloadSmartWishlist !== 'undefined') {
          window.ReloadSmartWishlist();
        } else if (window.swat) {
          if (window.swat.initializeActionBtns) {
            window.swat.initializeActionBtns();
          }
          if (window.swat.init) {
            window.swat.init();
          }
        } else if (window._swat) {
          if (window._swat.initializeActionBtns) {
            window._swat.initializeActionBtns();
          }
        } else {
          // Dispatch custom events for alternative wishlist implementations
          document.dispatchEvent(new CustomEvent('wishlist:refresh'));
          document.dispatchEvent(new CustomEvent('swym:refresh'));
          
          // Check if there's a global function
          if (typeof smartwishlist !== 'undefined') {
            smartwishlist();
          }
        }
      }, 100);
      
      isProcessing = false;
    }, 50);
  }
  
  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addWishlistIcons);
  } else {
    addWishlistIcons();
  }
  
  // Multiple strategies to catch AJAX pagination changes
  
  // Strategy 1: Boost custom events
  document.addEventListener('boost-sd:after-rendering', function() {
    setTimeout(addWishlistIcons, 150);
  });
  
  document.addEventListener('boost-sd:pagination:changed', function() {
    setTimeout(addWishlistIcons, 150);
  });
  
  document.addEventListener('boost-sd:filter:changed', function() {
    setTimeout(addWishlistIcons, 150);
  });
  
  // Strategy 2: Listen for clicks on pagination buttons
  document.addEventListener('click', function(e) {
    const paginationBtn = e.target.closest('.boost-sd__pagination-button, .boost-sd__pagination-item, [data-boost-pagination]');
    if (paginationBtn) {
      setTimeout(addWishlistIcons, 300);
      setTimeout(addWishlistIcons, 600);
    }
  }, true);
  
  // Strategy 3: Observe for dynamic content changes with aggressive detection
  const observer = new MutationObserver(function(mutations) {
    let shouldUpdate = false;
    mutations.forEach(function(mutation) {
      // Check for added nodes
      if (mutation.addedNodes && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // ELEMENT_NODE
            if (node.classList && node.classList.contains('boost-sd__product-item')) {
              shouldUpdate = true;
            } else if (node.querySelector && node.querySelector('.boost-sd__product-item')) {
              shouldUpdate = true;
            } else if (node.classList && (node.classList.contains('boost-sd__product-list') || 
                       node.classList.contains('boost-sd__product-list-wrapper') ||
                       node.classList.contains('boost-sd'))) {
              shouldUpdate = true;
            }
          }
        });
      }
      
      // Check for removed nodes (page is being replaced)
      if (mutation.removedNodes && mutation.removedNodes.length > 0) {
        mutation.removedNodes.forEach(function(node) {
          if (node.nodeType === 1 && node.classList && 
              (node.classList.contains('boost-sd__product-item') || 
               node.querySelector && node.querySelector('.boost-sd__product-item'))) {
            shouldUpdate = true;
          }
        });
      }
      
      // Also check for attribute changes
      if (mutation.type === 'attributes' && mutation.target.classList && 
          (mutation.target.classList.contains('boost-sd') || 
           mutation.target.classList.contains('boost-sd__product-list'))) {
        shouldUpdate = true;
      }
    });
    
    if (shouldUpdate) {
      setTimeout(addWishlistIcons, 150);
    }
  });
  
  // Start observing the document for changes
  const targetNode = document.querySelector('.boost-sd') || document.body;
  observer.observe(targetNode, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'data-page', 'data-total-page']
  });
  
  // Strategy 4: Aggressive polling - check every second
  setInterval(function() {
    var allProducts = document.querySelectorAll('.boost-sd__product-item');
    var productsWithoutWishlist = 0;
    
    allProducts.forEach(function(product) {
      if (!product.querySelector('.smartwishlist')) {
        productsWithoutWishlist++;
      }
    });
    
    if (productsWithoutWishlist > 0) {
      addWishlistIcons();
    }
  }, 1000);
  
  // Strategy 5: Intercept fetch/XHR to detect AJAX requests
  var originalFetch = window.fetch;
  window.fetch = function() {
    return originalFetch.apply(this, arguments).then(function(response) {
      // If it's a Boost API call, add icons after response
      if (response.url && (response.url.indexOf('boost') !== -1 || response.url.indexOf('search') !== -1 || response.url.indexOf('filter') !== -1)) {
        setTimeout(addWishlistIcons, 200);
        setTimeout(addWishlistIcons, 500);
      }
      return response;
    });
  };
})();

// (function () {
//   // --- Helpers ---
//   function applyBoostCartMeta() {
//     console.log(window.__CART_DELIVERY__);
//     const deliveryMap = window.__CART_DELIVERY__ || {};
//     const nodes = document.querySelectorAll('.js-delivery-time[data-variant-id]');
// console.log(deliveryMap);
//     console.log('[applyBoostCartMeta] deliveryMap keys:', Object.keys(deliveryMap).length, 'nodes:', nodes.length);

//     if (!nodes.length) return;
// console.log(1);
//     nodes.forEach((el) => {
//       const variantId = el.getAttribute('data-variant-id');
//       console.log(variantId);
//       const info = deliveryMap[String(variantId)];
// console.log(info);
//       if (!info) return;

//       el.innerHTML = `
//         <span class="delivery_color">
//           <span class="f-black">${info.label || ''}</span><br>
//           <span class="${info.klass || ''}">${info.text || ''}</span>
//         </span>
//       `;
//     });
//   }

//   function setupBoostCartObserver() {
//     // Observe entire body because Boost may inject/re-render the cart modal dynamically
//     const observer = new MutationObserver((mutations) => {
//       for (const m of mutations) {
//         if (!m.addedNodes || !m.addedNodes.length) continue;

//         for (const node of m.addedNodes) {
//           if (!(node instanceof HTMLElement)) continue;

//           if (
//             node.matches?.('#boost-sd__modal-cart, .boost-sd__cart') ||
//             node.querySelector?.('#boost-sd__modal-cart, .boost-sd__cart')
//           ) {
//             applyBoostCartMeta();
//             return;
//           }
//         }
//       }
//     });

//     observer.observe(document.body, { childList: true, subtree: true });

//     // Also run once in case the cart is already in DOM
//     applyBoostCartMeta();
//   }

//   // --- Boost hooks ---
//   try {
//     const beforeAddToCart = (_, data) => {
//       console.log('[beforeAddToCart]', data);
//     };

//     const afterAddToCart = (_, data) => {
//       console.log('[afterAddToCart]', data);

//       // NOTE: __CART_DELIVERY__ is generated by Liquid on page load.
//       // If you add to cart via AJAX without page reload, the object may be outdated
//       // unless you refresh or prebuild it via another method.
//       applyBoostCartMeta();
//     };

//     boostWidgetIntegration.regisCustomization(beforeAddToCart);
//     boostWidgetIntegration.regisCustomization(afterAddToCart);
//   } catch (e) {
//     console.warn(e);
//   }

//   // Init observer ASAP
//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', setupBoostCartObserver);
//   } else {
//     setupBoostCartObserver();
//   }
// })();

// --- Fix Boost Sorting Dropdown Translation ---
(function() {
  'use strict';
  
  function fixSortingDropdown() {
    // Find Boost sorting button (contains &nbsp;)
    var sortButton = document.querySelector('.boost-sd__sorting-button');
    var sortValue = document.querySelector('.boost-sd__sorting-value');
    var sortOptions = document.querySelectorAll('.boost-sd__sorting-option');
    
    // Fix button - replace &nbsp; with empty space (label is in span)
    if (sortButton) {
      var btnText = sortButton.innerHTML;
      if (btnText.indexOf('&nbsp;') !== -1 || btnText.indexOf('\u00A0') !== -1) {
        // Replace &nbsp; with empty space, keep the span with selected value
        sortButton.childNodes.forEach(function(node) {
          if (node.nodeType === 3 && (node.textContent.indexOf('\u00A0') !== -1 || node.textContent.trim() === '')) {
            node.textContent = ' ';
          }
        });
        console.log('[Boost Custom] Fixed sort button &nbsp;');
      }
    }
    
    // Fix span with selected value - set to "Sortieren" if empty or &nbsp;
    if (sortValue) {
      var valText = sortValue.textContent.trim();
      if (!valText || valText === '&nbsp;' || valText === '\u00A0') {
        sortValue.textContent = 'Sortieren';
        console.log('[Boost Custom] Fixed sort value to: Sortieren');
      }
    }
    
    // Fix aria-label on toolbar item
    var toolbarItem = document.querySelector('.boost-sd__toolbar-item--sorting');
    if (toolbarItem && toolbarItem.getAttribute('aria-label') === '&nbsp;') {
      toolbarItem.setAttribute('aria-label', 'Sortieren');
    }
    
    // Fix sorting options if they have &nbsp;
    sortOptions.forEach(function(option) {
      if (option.textContent.indexOf('\u00A0') !== -1 || option.textContent.trim() === '') {
        var value = option.getAttribute('data-value');
        if (value) {
          // Map values to German labels
          var labels = {
            'relevance': 'Relevanz',
            'created-descending': 'Neueste',
            'created-ascending': '\u00C4lteste',
            'price-ascending': 'Preis: niedrig zu hoch',
            'price-descending': 'Preis: hoch zu niedrig',
            'title-ascending': 'Alphabetisch: A-Z',
            'title-descending': 'Alphabetisch: Z-A',
            'best-selling': 'Bestseller'
          };
          option.textContent = labels[value] || 'Sortieren';
          console.log('[Boost Custom] Fixed sort option:', value, '->', labels[value]);
        }
      }
    });
  }
  
  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixSortingDropdown);
  } else {
    fixSortingDropdown();
  }
  
  // Also run after Boost loads (with delays)
  setTimeout(fixSortingDropdown, 500);
  setTimeout(fixSortingDropdown, 1000);
  setTimeout(fixSortingDropdown, 2000);
  setTimeout(fixSortingDropdown, 3000);
  
  // Watch for changes (Boost may load via AJAX)
  var observer = new MutationObserver(function(mutations) {
    var shouldFix = false;
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            if (node.classList && (
              node.classList.contains('boost-sd__sorting-button') ||
              node.classList.contains('boost-sd__sorting') ||
              node.classList.contains('boost-sd__toolbar-item--sorting') ||
              (node.querySelector && node.querySelector('.boost-sd__sorting-button'))
            )) {
              shouldFix = true;
            }
          }
        });
      }
    });
    if (shouldFix) {
      fixSortingDropdown();
    }
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
  
  console.log('[Boost Custom] Sorting translation fix initialized');
})();
// --- End Boost Sorting Dropdown Translation Fix ---